import { useLocation } from 'react-router';

export default function useQueryNumberParam(
  param: string,
  defaultValue: number
): number {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const getNumberParam = (key: string): number | null => {
    return searchParams.has(key) ? Number(searchParams.get(key)) : null;
  };

  return getNumberParam(param) ?? defaultValue;
}
